export default __webpack_public_path__ + "static/media/hero-bg-2@2x.a10935af.webp";